/**
 * Created by macie_000 on 2016-05-20.
 */
var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.VIDEO_CONSULTATION_TEST = {
    RECORDING: 'RECORDING',
    STREAMING: 'STREAMING',
    WAIT: 'WAIT',
    STAND_BY: 'STAND_BY'
};

Object.freeze(Enum.MEEDY.VIDEO_CONSULTATION_TEST);